import { compareDates } from "@omnia/shared/utils/date"
import { INutritionPlanProductApp } from "../../../types"
import { ProductApplicationVm } from "./productApplicationVm"

export function compareApplicationVms(a1: ProductApplicationVm, a2: ProductApplicationVm) {

    a1.updateTargetModel(a1.productApp, false)
    var currentApp = a1.productApp

    a2.updateTargetModel(a2.productApp, false)
    var otherApp = a2.productApp

    return compareApplications(currentApp, otherApp)

}

export function compareApplications(a1: INutritionPlanProductApp, a2: INutritionPlanProductApp) {

    if (a1.NutritionPlanProductAppId !== a2.NutritionPlanProductAppId) {
        return false;
    }

    if (a1.FertiliserId !== a2.FertiliserId ||
        a1.ManureId !== a2.ManureId) {
        return false;
    }

    if (a1.TargetNutrient !== a2.TargetNutrient) {
        return false;
    }

    if (!compareDates(a1.ApplicationDate, a2.ApplicationDate)) {
        return false;
    }

    if (!compareDates(a1.ActualDate, a2.ActualDate)) {
        return false;
    }

    if (a1.NutrientPct !== a2.NutrientPct ||
        a1.NutrientRate !== a2.NutrientRate ||
        a1.ProductRate !== a2.ProductRate) {
        return false;
    }

    if (a1.AutoComplete !== a2.AutoComplete) {
        return false;
    }

    if (a1.Incorporation !== a2.Incorporation ||
        a1.ActualIncorporation !== a2.ActualIncorporation) {
        return false;
    }

    if (a1.GrowthStage !== a2.GrowthStage) {
        return false;
    }

    var currentOverrides = a1.Cropping;
    var otherOverrides = a2.Cropping;

    if ((currentOverrides && otherOverrides) && currentOverrides.length !== otherOverrides.length) {
        return false;
    }

    var res = true;

    if (currentOverrides) {
        currentOverrides.forEach(o => {
            var oo = otherOverrides.find(ov => ov.CroppingId === o.CroppingId);
            if (!oo) {
                res = false;
            } else if (oo.ProductRate !== o.ProductRate ||
                oo.NutrientRate !== o.NutrientRate ||
                oo.NutrientPct !== o.NutrientPct) {
                res = false;
            }
        });
    }

    return res;
}
